// Copyright (c) 2016 Deere & Company

import {fetchEmissionsQualification, resetEmissionsPartSearch} from './report';
import {sharedActionCreators} from '../../shared/action-creators';
import {updateEmissionsPartSearchCriteria} from './criteria';

export default {
    fetchEmissionsQualification,
    resetEmissionsPartSearch,
    updateEmissionsPartSearchCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/action-creators/index.js